import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { useQuery } from '#src/hooks/graphql/useQuery.ts';

import type {
  DeckQuery,
  DeckQueryVariables,
} from './__generated__/useDeck.graphql.ts';
import { deckFragment } from './fragments.ts';

const DECK_QUERY = gql`
  query DeckQuery($name: String!, $sport: Sport!) {
    currentUser {
      slug
      userSportProfile: anyUserSportProfile(sport: $sport) {
        id
        deck(name: $name) {
          slug
          cards(first: 50) {
            nodes {
              slug
            }
          }
          ...deckFragments_deck
        }
      }
    }
  }
  ${deckFragment}
` as TypedDocumentNode<DeckQuery, DeckQueryVariables>;

type Props = {
  sport: Sport;
  name?: string;
  skip?: boolean;
};

export const useDeck = ({ sport, name, skip: skipProp }: Props) => {
  const { data, loading } = useQuery(DECK_QUERY, {
    variables: {
      sport,
      name: name || '',
    },
    skip: !name || skipProp,
  });

  return {
    deck: data?.currentUser?.userSportProfile?.deck,
    loading,
  };
};
